<template>
    <loading-spinner v-if="isLoading"></loading-spinner>
    <div v-else>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">자주하는 질문</span>
            <span class="txt">센터 admin에 보여질 자주하는 질문사항과 답변 게시글을 작성 할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="!questionDetail"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/question/list">목록</router-link>
                    <router-link v-if="careAuth === true" :to="`/madmin/question/edit/${id}`" class="com-btn blue">
                        수정
                    </router-link>
                    <button v-if="careAuth === true" class="com-btn red" @click="deleteQuestion(questionDetail.id)">
                        삭제
                    </button>
                </div>
            </div>
            <table class="com-table view">
                <colgroup>
                    <col style="width: 170px" />
                    <col style="width: auto" />
                    <col style="width: 170px" />
                    <col style="width: auto" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>카테고리</th>
                        <td>{{ questionDetail.boardCategory === null ? '' : questionDetail.boardCategory.name }}</td>
                        <th>글쓴이</th>
                        <td>
                            {{
                                questionDetail.info.createdName === 'root@root.com'
                                    ? '핏투데이케어'
                                    : questionDetail.info.createdName
                            }}
                        </td>
                    </tr>
                    <tr>
                        <th>조회수</th>
                        <td>{{ questionDetail.viewCount }}</td>
                        <th>등록일</th>
                        <td>{{ questionDetail.info.createdAt | timestampFilter }}</td>
                    </tr>
                    <tr>
                        <th>첨부파일</th>
                        <td colspan="3">
                            <a
                                v-for="(file, index) in fileList"
                                :key="index"
                                :href="file.fileUrl"
                                class="file-down"
                                style="cursor: pointer"
                            >
                                {{ file.name }}
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th>제목</th>
                        <td colspan="3">{{ questionDetail.title }}</td>
                    </tr>
                    <tr>
                        <td class="no-padding no-side-border" colspan="4">
                            <div class="txt-view">
                                <div class="ck-content" v-html="questionDetail.content"></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/question/list">목록</router-link>
                    <router-link v-if="careAuth === true" :to="`/madmin/question/edit/${id}`" class="com-btn blue">
                        수정
                    </router-link>
                    <button v-if="careAuth === true" class="com-btn red" @click="deleteQuestion(questionDetail.id)">
                        삭제
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';

export default {
    name: 'questionDetail',
    components: { LoadingSpinner },
    props: {},
    computed: {
        isCareAdmin() {
            return this.$store.getters['auth/isCareAdmin'];
        },
        isSystemAdmin() {
            return this.$store.getters['auth/isSystemAdmin'];
        },
    },
    mounted() {
        if (this.isCareAdmin || this.isSystemAdmin) {
            // 케어 권한 확인
            this.careAuth = true;
        }
        this.fetchQuestionDetail();
    },
    data() {
        return {
            careAuth: false,
            isLoading: false,
            id: this.$route.params.id,
            questionDetail: null,
            fileList: null,
        };
    },

    methods: {
        // 자주하는 질문 상세 Fetch
        async fetchQuestionDetail() {
            try {
                const { data } = await this.getQuestionDetail(this.id);
                this.questionDetail = data;

                if (data.fileGroupId) {
                    // fileGroupId가 있으면 파일 목록 fetch
                    const fileGroupData = await this.getQuestionDetailFileGroup(data.fileGroupId);
                    this.fileList = fileGroupData.data;
                }

                console.log('===> Success Loading Question Detail', data);
            } catch (error) {
                console.log(error);
            }
        },

        // 자주하는 질문 삭제
        async deleteQuestion(id) {
            try {
                this.isLoading = true;
                const { data } = await this.getDeleteQuestion(id);
                alert('질문을 삭제했습니다.');
                this.isLoading = false;
                console.log('===> Success Delete Question', data);
                this.$router.push({ name: 'questionList' });
            } catch (error) {
                console.log(error);
            }
        },

        // 자주하는 질문 상세 API
        getQuestionDetail(id) {
            return api.get(`/admin/api/ft/board/faq/${id}/view`);
        },

        // 자주하는 질문 상세 첨부 파일 리스트 API
        getQuestionDetailFileGroup(fileGroupId) {
            return api.get(`/admin/api/board/file-group/${fileGroupId}`);
        },

        // 자주하는 질문 삭제 API
        getDeleteQuestion(id) {
            return api.delete(`/admin/api/ft/board/faq/${id}`);
        },

        // a 태그 파일 다운로드 이벤트
        fileDownload(url) {
            api.post(url, {
                responseType: 'blob',
            })
                .then((response) => {
                    const blob = new Blob([response.data], { type: 'image/png' });

                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    const filename = replaceAll(decodeURI(response.headers.filename), '+', ' ');
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>
<style scoped src="@/assets/js/ckeditor/ckeditor.css"></style>
<!-- ckeditor5 css -->
<style lang="scss" scoped>
a.file-down::after {
    content: ',' attr(file-down);
    margin-right: 5px;
}

a.file-down:last-of-type::after {
    content: '';
}
</style>
